import { render, staticRenderFns } from "./ServiceTax.vue?vue&type=template&id=dcf88972&scoped=true"
import script from "./ServiceTax.vue?vue&type=script&lang=js"
export * from "./ServiceTax.vue?vue&type=script&lang=js"
import style0 from "./ServiceTax.vue?vue&type=style&index=0&id=dcf88972&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf88972",
  null
  
)

export default component.exports